import React, { useState } from "react";
import { Button, MainContainer, Section } from "./styles";
import CustomButton from "../CustomButton";

const options = [
  { icon: "description", label: "Descripción", key: "description" },
  { icon: "dataset", label: "Ficha técnica", key: "datasheet" },
  { icon: "image", label: "Imágenes", key: "images" },
];

const EditionTabs = ({ selectedSection, onSectionChange }) => {
  return (
    <MainContainer>
      {options.map(({ icon, label, key }) => (
        <Button
          key={key}
          onClick={() => onSectionChange(key)}
          isActive={selectedSection === key}
        >
          <p className="tab-text">
            <span className="icon-tab material-symbols-outlined">{icon}</span>
            {label}
          </p>
        </Button>
      ))}
    </MainContainer>
  );
};

export default EditionTabs;
